import React from 'react';
import "../videosecond/VideoSecond.css";

const VideoSecond = () => {


  return (
    <div
      className="py-5 fade-up border-top"
    >
      <div style={{ width: '100%' }}>
        <h1 className="mb-3 textRes px-2 text-uppercase text-center">
          India’s Leading <span style={{ color: '#a20000' }}> Solar Module Plant </span>
        </h1>

        {/* Video Container */}
        <div
          className="position-relative "
          style={{
            width: '100%',
            overflow: 'hidden',
            aspectRatio: '16/9',
          }}
        >
          <video
          
            style={{
              width:'100%',
              objectFit: 'cover',
              transition: 'transform 0.5s ease',
            }}
            loop
            autoPlay
            muted
            playsInline
            preload='auto'
            src="/Renew X 2025 (1).mp4"
            
          ></video>
         
          {/* Overlay */}
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{ background: 'rgba(0,0,0,0.15)' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default VideoSecond;


























